import { Control, Controller, UseFormGetValues } from "react-hook-form";
import { css } from "../../../styled-system/css";
import { Product } from "../../api/schemas";
import { FormValues } from "../../types/form";
import { Path } from "../../types/route";
import { ConfirmContainer } from "../confirm";
import { SelectColorContainer } from "../selectColor";
import { SelectWidthAndSizeContainer } from "../selectWidthAndSize";

export interface CustomOrderProps {
  path: string;
  setPath: (path: Path) => void;
  control: Control<FormValues>;
  getValues: UseFormGetValues<FormValues>;
  product: Product | undefined;
}

export function CustomOrder({
  path,
  setPath,
  control,
  getValues,
  product,
}: CustomOrderProps) {
  return (
    <div
      className={css({
        bg: "black.100",
        width: "100%",
        minHeight: "100vh",
        pb: "calc(134px + 112px)",
      })}
    >
      {path === "select_color" || path === "change_color" ? (
        <Controller
          key="color"
          control={control}
          name="color"
          rules={{ required: true }}
          render={({
            field: { value, onChange },
            fieldState: { isDirty, error },
          }) => (
            <SelectColorContainer
              path={path}
              setPath={setPath}
              value={value}
              onChange={onChange}
              isDirty={isDirty}
              error={error}
              colors={product?.colors ?? []}
            />
          )}
        />
      ) : path === "select_width_and_size" ||
        path === "change_width_and_size" ? (
        <Controller
          key="widthAndSize"
          control={control}
          name="widthAndSize"
          rules={{
            validate: {
              customValidate: (value) =>
                !!value.leftWidth &&
                !!value.leftSize &&
                !!value.rightWidth &&
                !!value.rightSize,
            },
          }}
          render={({
            field: { value, onChange },
            fieldState: { isDirty, error },
          }) => (
            <>
              <SelectWidthAndSizeContainer
                footLengths={product?.foot_lengths ?? []}
                footWidths={product?.foot_widths ?? []}
                path={path}
                setPath={setPath}
                value={value}
                onChange={onChange}
                isDirty={isDirty}
                error={error}
              />
            </>
          )}
        />
      ) : (
        <Controller
          key="isConsented"
          control={control}
          name="isConsented"
          render={({ field: { value, onChange } }) => (
            <ConfirmContainer
              setPath={setPath}
              getValues={getValues}
              value={value}
              onChange={onChange}
              parentCode={product?.parent_code}
            />
          )}
        />
      )}
    </div>
  );
}
